module.exports = __webpack_public_path__ + "static/img/irole.3192b9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/swbnzk/irole.png
// module id = sYmE
// module chunks = 7